module.exports = __webpack_public_path__ + "img/47f53fb.jpg";